import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    isRegenLoading: false,
    data: null,
    message: null,
    error: null,
    createStatus: null,
    updateStatus: null,
    updatedData: null,
    deleteStatus: null,
    generateStatus: null,
    fetchStatus: null,
    researchData: null,
    generatedData: null,
    productsData: null,
    createProductStatus: null,
    updateProductStatus: null,
    createProductData: null,
    updateProductData: null,
    communicationMailData: null,
    replyData: null
}

const promptSlice = createSlice({
    name: 'prompt',
    initialState,
    reducers: {
        getPromptStart: (state) => {
            state.isLoading = true;
            state.data = null;
            state.error = null;
        },
        getPromptSuccess: (state, action) => {
            state.data = action?.payload?.prompts;
            state.isLoading = false;
        },
        getPromptFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        createPromptStart: (state, action) => {
            state.isLoading = true;
            state.createStatus = null;
        },
        createPromptSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        createPromptFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createStatus = action?.payload?.success;
        },
        updatePromptStart: (state, action) => {
            state.isLoading = true;
            state.updateStatus = null;
            state.updatedData = null;
        },
        updatePromptSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
            state.data = [action?.payload?.updatePrompts];
        },
        updatePromptFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateStatus = action?.payload?.success;
        },
        deletePromptStart: (state, action) => {
            state.isLoading = true;
            state.deleteStatus = null;
        },
        deletePromptSuccess: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        deletePromptFailure: (state, action) => {
            state.isLoading = false;
            state.deleteStatus = action?.payload?.success;
        },
        getResearchContentStart: (state) => {
            state.isLoading = true;
            state.researchData = null;
            state.error = null;
            state.fetchStatus = null;
        },
        getResearchContentSuccess: (state, action) => {
            state.researchData = action?.payload?.gpt_response;
            state.isLoading = false;
            state.fetchStatus = action?.payload?.success;
        },
        getResearchContentFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        createResearchContentStart: (state, action) => {
            state.isLoading = true;
            // state.message = null;
            state.generateStatus = null;
            state.generatedData = null
        },
        createResearchContentSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.generateStatus = action?.payload?.success;
            state.generatedData = action?.payload?.savedGptResponse;
        },
        createResearchContentFailure: (state, action) => {
            state.isLoading = false;
            // state.message = action?.payload?.message;
            state.generateStatus = action?.payload?.success;
        },
        getRegenResearchContentStart: (state) => {
            state.isRegenLoading = true;
            state.researchData = null;
            state.error = null;
            state.fetchStatus = null;
        },
        getRegenResearchContentSuccess: (state, action) => {
            state.researchData = action?.payload?.gpt_response;
            state.isRegenLoading = false;
            state.fetchStatus = action?.payload?.success;
        },
        getRegenResearchContentFailure: (state, action) => {
            state.error = action?.payload;
            state.isRegenLoading = false;
        },
        createRegenResearchContentStart: (state, action) => {
            state.isRegenLoading = true;
            // state.message = null;
            state.generateStatus = null;
            state.generatedData = null
        },
        createRegenResearchContentSuccess: (state, action) => {
            state.isRegenLoading = false;
            state.message = action?.payload?.message;
            state.generateStatus = action?.payload?.success;
            state.generatedData = action?.payload?.savedGptResponse;
        },
        createRegenResearchContentFailure: (state, action) => {
            state.isRegenLoading = false;
            // state.message = action?.payload?.message;
            state.generateStatus = action?.payload?.success;
        },
        resetState: (state) => {
            state.isLoading = false;
            state.isRegenLoading = false;
            state.message = null;
            state.error = null;
            state.createStatus = null;
            state.updateStatus = null;
            state.updatedData = null;
            state.deleteStatus = null;
        },
        resetGenerateStatus: (state) => {
            state.generateStatus = false;
            state.generatedData = null;
        },
        // products
        getProductStart: (state) => {
            state.isLoading = true;
            state.productsData = null;
            state.error = null;
            state.createProductData = null;
            state.updateProductData = null;
        },
        getProductsSuccess: (state, action) => {
            state.productsData = action?.payload?.prompts;
            state.isLoading = false;
        },
        getProductsFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        createProductStart: (state, action) => {
            state.isLoading = true;
            state.createProductStatus = null;
            state.createProductData = null;
        },
        createProductSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createProductStatus = action?.payload?.success;
            state.createProductData = action?.payload?.savedProductFile;
        },
        createProductFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.createProductStatus = action?.payload?.success;
        },
        updateProductStart: (state, action) => {
            state.isLoading = true;
            state.updateProductStatus = null;
            state.updateProductData = null;
        },
        updateProductSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateProductStatus = action?.payload?.success;
            state.updateProductData = action?.payload?.updatePrompts;
        },
        updateProductFailure: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload?.message;
            state.updateProductStatus = action?.payload?.success;
        },
        getCommunicationMailDataStart: (state) => {
            state.isLoading = true;
            state.communicationMailData = null;
            state.error = null;
        },
        getCommunicationMailDataSuccess: (state, action) => {
            state.communicationMailData = action?.payload?.ai_communication;
            state.isLoading = false;
        },
        getCommunicationMailDataFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        resetProductState: (state) => {
            state.isLoading = false;
            state.message = null;
            state.error = null;
            state.createProductStatus = null;
            state.updateProductStatus = null;
        },
        getRedirectURIStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        getRedirectURISuccess: (state, action) => {
            state.isLoading = false;
            state.message = action?.payload;
        },
        getRedirectURIFailure: (state, action) => {
            state.isLoading = false;
            state.error = action?.payload;
        },
        getReplyDataStart: (state) => {
            state.isLoading = null;
            state.error = null;
            state.replyData = null;
        },
        getReplyDataSuccess: (state, action) => {
            state.isLoading = false;
            state.replyData = action?.payload?.data;
        },
        getReplyDataFailure: (state, action) => {
            state.error = action?.payload;
            state.isLoading = false;
        },
        resetReplyData: (state) => {
            state.isLoading = false;
            state.error = null;
            state.replyData = null;
        },

    }
});
export const {
    getPromptStart,
    getPromptSuccess,
    getPromptFailure,
    createPromptStart,
    createPromptSuccess,
    createPromptFailure,
    updatePromptStart,
    updatePromptSuccess,
    updatePromptFailure,
    deletePromptStart,
    deletePromptSuccess,
    deletePromptFailure,
    getResearchContentStart,
    getResearchContentSuccess,
    getResearchContentFailure,
    resetGenerateStatus,
    createResearchContentStart,
    createResearchContentSuccess,
    createResearchContentFailure,
    resetState,
    getProductStart,
    getProductsSuccess,
    getProductsFailure,
    createProductStart,
    createProductSuccess,
    createProductFailure,
    updateProductStart,
    updateProductSuccess,
    updateProductFailure,
    getCommunicationMailDataStart,
    getCommunicationMailDataSuccess,
    getCommunicationMailDataFailure,
    resetProductState,
    getRedirectURIStart,
    getRedirectURISuccess,
    getRedirectURIFailure,
    getRegenResearchContentStart,
    getRegenResearchContentSuccess,
    getRegenResearchContentFailure,
    createRegenResearchContentStart,
    createRegenResearchContentSuccess,
    createRegenResearchContentFailure,
    getReplyDataStart,
    getReplyDataSuccess,
    getReplyDataFailure,
    resetReplyData
} = promptSlice?.actions;

export default promptSlice?.reducer;